module.exports = __webpack_public_path__ + "img/app-sc-2.b6d5bf51.png";